import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "./contexts/ThemeContext";
import ErrorBoundary from "./components/ErrorBoundary";
import MainLayout from "./components/layout/MainLayout";
import { ContactDataProvider } from "./hooks/useContactData";

import About from "./pages/About";
import AccountDeletion from "./pages/AccountDeletion";
import Contact from "./pages/Contact";
import FAQ from "./pages/FAQ";
import Home from "./pages/Home";
import HowItWorks from "./pages/HowItWorks";
import Industries from "./pages/Industries";
import LegalPage from "./pages/LegalPage";
import NotFound from "./pages/NotFound";
import Pricing from "./pages/Pricing";
import ResourceDetail from "./pages/ResourceDetail";
import Resources from "./pages/Resources";
import Security from "./pages/Security";
import ServiceDetail from "./pages/ServiceDetail";
import Services from "./pages/Services";

const queryClient = new QueryClient();

function App() {
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <ContactDataProvider>
            <ErrorBoundary>
              <Routes>
                <Route element={<MainLayout />}>
                  <Route index element={<Home />} />
                  <Route path="/home" element={<Navigate to="/" replace />} />
                  <Route path="/services" element={<Services />} />
                  <Route path="/services/:slug" element={<ServiceDetail />} />
                  <Route path="/how-it-works" element={<HowItWorks />} />
                  <Route path="/industries" element={<Industries />} />
                  <Route path="/pricing" element={<Pricing />} />
                  <Route path="/security" element={<Security />} />
                  <Route path="/faq" element={<FAQ />} />
                  <Route path="/resources" element={<Resources />} />
                  <Route path="/resources/:slug" element={<ResourceDetail />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/privacy-policy" element={<LegalPage slug="privacy-policy" />} />
                  <Route path="/terms-of-service" element={<LegalPage slug="terms-of-service" />} />
                  <Route path="/terms" element={<Navigate to="/terms-of-service" replace />} />
                  <Route path="/refund-policy" element={<LegalPage slug="refund-policy" />} />
                  <Route path="/cookie-policy" element={<LegalPage slug="cookie-policy" />} />
                  <Route path="/business-policy" element={<LegalPage slug="business-policy" />} />
                  <Route path="/legal/:slug" element={<LegalPage />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/account-deletion" element={<AccountDeletion />} />
                  <Route path="*" element={<NotFound />} />
                </Route>
              </Routes>
            </ErrorBoundary>
          </ContactDataProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ThemeProvider>
  );
}

export default App;
